import { Component, inject } from '@angular/core';
import { ToastService } from './toast.service';

import { NgbToast, NgbToastHeader } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  imports: [NgbToast, NgbToastHeader],
})
export class ToastComponent {
  toastService = inject(ToastService);
}
